import { ItemList, ItemType } from "../../../UI/Cube/types";
// import tour from "../../../../assets/image/cube/tiles/tour.webp";
// import politik from "../../../../assets/image/cube/tiles/Underconstruction-03.webp";
// import briefwahl from "../../../../assets/image/cube/tiles/06-Briefwahl.webp";
// import olaf from "../../../../assets/image/cube/tiles/Kanzler-Brief-03.webp";
// import tinder from "../../../../assets/image/cube/tiles/04-Tinder.webp";
// import kandiOverview from "../../../../assets/image/cube/tiles/Underconstruction-07.webp";

import gda from "../../../../assets/image/cube/tiles/GDA.webp";
import indien from "../../../../assets/image/cube/tiles/Indien.webp";
import konfigurator from "../../../../assets/image/cube/tiles/Konfigurator.webp";
import malaysia from "../../../../assets/image/cube/tiles/Malaysia.webp";
import operations from "../../../../assets/image/cube/tiles/Operations.webp";
import referenzen from "../../../../assets/image/cube/tiles/Referenzen.webp";

const getHomeItems = (redirect?: string): ItemList => {
  return [
    {
      type: ItemType.IMAGE,
      src: indien,
      link: "https://www.mps-archonic.com/ueber-uns/standorte/",
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: malaysia,
      link: "https://www.mps-archonic.com/ueber-uns/standorte/",
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: referenzen,
      link: "https://www.mps-archonic.com/referenzen/",
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: operations,
      link: "https://www.mps-archonic.com/leistungen/operations-consulting/",
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: gda,
      link: "https://www.mps-archonic.com/referenzen/roesler-innowelt/",
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: konfigurator,
      link: "https://www.mps-archonic.com/leistungen/neue-arbeitswelten/",
      openExternal: true,
    },
  ];
};

export default getHomeItems;
